// /en/careers — hub (EN).
import { createFileRoute } from "@tanstack/react-router";
import { HubPage } from "@/careers/HubPage";
import { careersHead } from "@/careers/head";
import { UI } from "@/careers/spheres";

const ALT = { az: "/az/careers", ru: "/careers", en: "/en/careers" } as const;

export const Route = createFileRoute("/en/careers/")({
  head: () =>
    careersHead({
      lang: "en",
      canonicalPath: "/en/careers",
      altPaths: ALT,
      title: UI.en.metaTitleHub,
      description: UI.en.metaDescHub,
    }),
  component: () => <HubPage lang="en" />,
});
